import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

function FirmLoginGate() {
    const location = useLocation()
    const isFirmLog = useSelector((state) => Boolean(state.firmLogin?.isLog))

    if (!isFirmLog) {
        return (
            <Navigate
                to='/FirmLogin'
                replace
                state={{ prelocation: { pathname: location.pathname } }}
            />
        )
    }

    return <Outlet />
}

export default FirmLoginGate
